/**
 * Google Ads Configuration
 * All ad units, size mappings, and layout-specific settings
 */

export const googleAdsConfig = {
  // Network code
  networkCode: '23314305133',

  // Ad unit paths
  adUnits: {
    // First review ad units
    firstReview: {
      top: 'ch1_ReviewStream_Top',
      contentInner: 'ch1_ReviewStream_contentInner',
      underContent: 'ch1_ReviewStream_underContent',
      comments: 'ReviewStream_comments'
    },
    // Second review+ ad units
    secondReview: {
      top: 'ch2_ReviewStream_Top',
      contentInner: 'ch2_ReviewStream_contentInner',
      underContent: 'ch2_ReviewStream_underContent',
      comments: 'ReviewStream_comments' // Same for all
    }
  },

  // Size mappings for different ad types
  sizeMappings: {
    // Top banner mapping
    topBanner: [
      { viewport: [420, 0], sizes: [[970, 250], [930, 180]] },
      { viewport: [0, 0], sizes: [[400, 300], [336, 280], [320, 480], [300, 250]] }
    ],

    // Middle/inner content mapping
    contentInner: [
      { viewport: [420, 0], sizes: [[980, 120], [970, 250], [930, 180], [750, 300], [750, 200], [750, 100]] },
      { viewport: [0, 0], sizes: [[336, 280], [320, 480], [320, 100], [300, 600], [300, 250]] }
    ],

    // Bottom/under content mapping
    underContent: [
      { viewport: [420, 0], sizes: [[970, 250], [930, 180], [750, 300]] },
      { viewport: [0, 0], sizes: [[400, 300], [336, 280], [320, 480], [300, 600], [300, 250]] }
    ],

    // Comment banner mapping
    comments: [
      { viewport: [420, 0], sizes: [[980, 120], [970, 250], [930, 180], [750, 300], [750, 200], [750, 100]] },
      { viewport: [0, 0], sizes: [[336, 280], [320, 480], [320, 100], [300, 600], [300, 250]] }
    ]
  },

  // Ad sizes for each slot type
  adSizes: {
    topBanner: [[970, 250], [930, 180], [400, 300], [336, 280], [320, 480], [300, 250]],
    contentInner: [[980, 120], [970, 250], [930, 180], [750, 300], [750, 200], [750, 100], [336, 280], [320, 480], [320, 100], [300, 600], [300, 250]],
    underContent: [[970, 250], [930, 180], [750, 300], [400, 300], [336, 280], [320, 480], [300, 600], [300, 250]],
    comments: [[980, 120], [970, 250], [930, 180], [750, 300], [750, 200], [750, 100], [336, 280], [320, 480], [320, 100], [300, 600], [300, 250]]
  },

  // Review types
  reviewTypes: {
    TEXT: 0,      // Text-based reviews
    IMAGES: 1     // Image-based reviews
  },

  // Ad layouts
  layouts: {
    LAYOUT_1A: '1a',
    LAYOUT_2: '2'
  },

  // Container ID patterns
  containerIds: {
    topBanner: (id) => `review-top-banner-${id}`,
    middleOne: (id) => `inner-banner-middleone-${id}`,
    bottom: (id) => `inner-banner-bottom-${id}`,
    imagesBottom: (id) => `inner-banner-images-bottom-${id}`,
    imagesPrefix: 'inner-banner-images-',
    commentBanner: (relationId) => `comment-banner-${relationId}`
  },

  // GPT Settings
  gptSettings: {
    scriptUrl: 'https://securepubads.g.doubleclick.net/tag/js/gpt.js',
    loadTimeout: 10000, // 10 seconds
    enableAsyncRendering: true,
    collapseEmptyDivs: true,
    singleRequest: true
  },

  // Ad slot definitions per review type and layout
  slotDefinitions: {
    // First review, text content, layout 1a or 2
    firstReviewTextLayout1a: {
      showMiddleOne: true,
      showBottom: true
    },
    // First review, text content, no specific layout
    firstReviewText: {
      showMiddleOne: true,
      showBottom: true
    },
    // First review, images
    firstReviewImages: {
      showImageAds: true,  // Ads between images (0-4)
      showBottom: true
    },
    // Second review+, text content, layout 1a or 2
    secondReviewTextLayout1a: {
      showMiddleOne: true,
      showBottom: true
    },
    // Second review+, text content, layout 2
    secondReviewTextLayout2: {
      showMiddleOne: false,  // No middle ad for layout 2
      showBottom: true
    },
    // Second review+, text content, default
    secondReviewTextDefault: {
      showMiddleOne: true,
      showBottom: true
    },
    // Second review+, images
    secondReviewImages: {
      showImageAds: true,
      showBottom: true
    }
  }
}

export default googleAdsConfig
